import React, { forwardRef, useEffect, useRef } from "react";
import "../styles/QuestionCountStepper_Styles.css";
import ReviewFlag from "../../../assets/images/assessment/review_flag.png";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import "react-horizontal-scrolling-menu/dist/styles.css";

import ForwardImg from "../../../assets/images/assessment/forward_img.png";
import BackwardImg from "../../../assets/images/assessment/backward_img.png";
import { QuestionListModel } from "../data/response/QuestionListModel";
interface QuestionScrollMenuProps {
  currentIndex: number;
  fetchedQuestions: QuestionListModel[];
  setCurrentQuestionTab: (index: number) => void;
  isDarkTheme: boolean;
}

const AssessmentBubbleSelector: React.FC<QuestionScrollMenuProps> = ({
  currentIndex,
  fetchedQuestions,
  setCurrentQuestionTab,
  isDarkTheme,
}) => {
  const questionRefs = useRef<(HTMLDivElement | null)[]>([]);
  useEffect(() => {
    if (questionRefs.current[currentIndex]) {
      questionRefs.current[currentIndex]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [currentIndex]);

  return (
    <div
      className="question-count-scrollcontainer"
      style={{
        border: isDarkTheme ? "1px solid #1A3A6B" : "",
      }}
    >
      <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow}>
        {fetchedQuestions.map((step, index) => (
          <QuestionBubble
            currentIndex={currentIndex}
            ref={(el) => (questionRefs.current[index] = el)}
            index={index}
            value={step}
            itemId={step.questionId}
            onTap={() => setCurrentQuestionTab(index)}
            fetchedLength={fetchedQuestions.length}
            isDarkTheme={isDarkTheme}
          />
        ))}
      </ScrollMenu>
    </div>
  );
};

export default AssessmentBubbleSelector;

export const QuestionBubble = forwardRef<
  HTMLDivElement,
  {
    currentIndex: number;
    index: number;
    value: QuestionListModel;
    onTap: () => void;
    fetchedLength: number;
    itemId: string;
    isDarkTheme: boolean;
  }
>(
  (
    {
      currentIndex,
      index,
      value,
      onTap,
      fetchedLength,
      itemId,
      isDarkTheme,
    }: {
      currentIndex: number;
      index: number;
      value: QuestionListModel;
      onTap: () => void;
      fetchedLength: number;
      itemId: string;
      isDarkTheme: boolean;
    },
    ref,
  ) => (
    <div
      ref={ref}
      className="question-stepper-item"
      id={`question-${itemId}`}
      style={
        {
          // border: isDarkTheme ? "1px solid #1A3A6B" : "",
        }
      }
      onClick={onTap}
    >
      {/* <div
        className={`question-stepper-circle
        ${index === currentIndex ? "current" : ""} ${
          value.saved === true ? "visited" : ""
        } ${value.showFlag ? "flagged" : ""}`}

       
      > */}
      <div
        className={`question-stepper-circle
    ${index === currentIndex ? "current" : ""}
    ${value.saved === true ? "visited" : ""}
    ${value.showFlag ? "flagged" : ""}
    
    ${isDarkTheme && value.saved ? "dark-visited" : ""}
    ${isDarkTheme && index === currentIndex ? "dark-current" : ""}
    ${isDarkTheme && value.showFlag ? "dark-flagged" : ""}
  `}
      >
        <p
          className={`question-stepper-circletext 
  ${index === currentIndex ? "current" : ""} 
  ${value.showFlag ? "flagged" : ""}
    ${isDarkTheme && value.saved ? "dark-visited" : ""}
    ${isDarkTheme && index === currentIndex ? "dark-current" : ""}
    ${isDarkTheme && value.showFlag ? "dark-flagged" : ""}
`}
        >
          {index + 1 < 10 ? `0${index + 1}` : index + 1}
        </p>
        {value.showFlag && <div className="question-red-dot"></div>}
      </div>
      {index !== fetchedLength - 1 && (
        <div
          className={`question-step-line ${
            isDarkTheme ? "question-step-line-dark" : ""
          }`}
        ></div>
      )}
    </div>
  ),
);
export function LeftArrow() {
  const visibility = React.useContext(VisibilityContext);
  const isFirstItemVisible = visibility.useIsVisible("first", true);

  return (
    <Arrow
      disabled={false}
      onClick={() => visibility.scrollPrev()}
      imageCls={`scroll-button left-arrow ${
        isFirstItemVisible ? "question-bubble-hidden-arrow" : ""
      }`}
      imgSrc={ForwardImg}
    ></Arrow>
  );
}
export function RightArrow() {
  const visibility = React.useContext(VisibilityContext);
  const isLastItemVisible = visibility.useIsVisible("last", false);
  return (
    <Arrow
      disabled={false}
      onClick={() => visibility.scrollNext()}
      imageCls={`scroll-button right-arrow ${
        isLastItemVisible ? "question-bubble-hidden-arrow" : ""
      }`}
      imgSrc={BackwardImg}
    />
  );
}

function Arrow({
  disabled,
  onClick,
  imageCls,
  imgSrc,
}: {
  disabled: boolean;
  onClick: VoidFunction;
  imgSrc?: string;
  imageCls?: string;
}) {
  return (
    <div className="top-padding-button">
      <img
        className={`${imageCls} ${disabled ? "disabled" : ""}`}
        onClick={onClick}
        src={imgSrc}
      />
    </div>
  );
}
